import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
// import moment from 'moment';
// import buildExportQuery from './queryies/_export_all';
import { saveAs } from 'file-saver';
import moment from 'moment';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
};

export const ITEMS_LIST = 'GET_CLIENT_LIST';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                id: 'departments.id',
                name: 'departments.name',
                created_at: 'departments.created_at',
                updated_at: 'departments.updated_at',
                departments: 'grouped_departments.departments'
              };

            const filter: any[] = [];

            if (query.name) {
                filter.push({ "$ilike": ["departments.name", {"$": `%${query.name}%`}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    from: 's:departments',
                    from_as: 'departments',
                    joins: [
                        {
                            join: 's:departments',
                            as:   'parent_departments',
                            on: {
                                $and: [
                                    { $eq: ['parent_departments.id', 'departments.parent_id'], },
                                    { $null: ['parent_departments.parent_id'] },
                                ]
                            }
                        },
                        {
                            join: {
                              columns: {
                                parent_id: 'departments.parent_id',
                                departments: {
                                    $array_agg: {
                                      $obj: {
                                        id: 'departments.id',
                                        name: 'departments.name',
                                        head_id: 'employees.id',
                                        head_name: 'employees.name',
                                        created_at: 'departments.created_at',
                                        updated_at: 'departments.updated_at',
                                      }
                                    }
                                  },
                              },
                              from: 's:departments',
                              from_as: 'departments',
                              joins: [
                                {
                                    join: 's:employees',
                                    as:   'employees',
                                    type: 'left',
                                    on: { $eq: ['employees.id', 'departments.head_id'], },
                                },
                              ],
                              groups: [
                                'departments.parent_id'
                              ],
                            //   where: {
                            //     $or: [
                            //       { $eq: ['dpc.is_sample', { $: true } ] },
                            //       { $eq: ['pc.is_sample', { $: true } ] },
                            //     ]
                            //   }
                            },
                            type: 'left',
                            as: 'grouped_departments',
                            on: { $eq: ['grouped_departments.parent_id', 'departments.id'] }
                        }
                    ],
                    // groups: [
                    //     'cl.id', 'cl.name', 'cl.category_income', 'cl.category_profit',
                    //     'empl.id', 'empl.name',
                    //     'city.id', 'city.name',
                    //     'ptype.id', 'ptype.name'
                    // ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            query.sortDirection == 'desc' ? { $desc: [columns[query.sortField || 'name' ]] } : { $asc: [columns[query.sortField || 'name']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ? 
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )
                    
                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

};

export const mutations: MutationTree<WorkPlanBoardState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_departments_manager';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
